var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.998 0A1 1 0 0124 1.001V18.6c0 .248-.093.488-.26.672l-4 4.401c-.005.006-.013.008-.019.013a.96.96 0 01-.273.196c-.019.01-.035.028-.055.037A1.009 1.009 0 0119 24H1a1 1 0 01-1-1V5c0-.008.005-.015.005-.024.002-.076.025-.146.044-.217.014-.055.017-.112.039-.163.022-.049.061-.088.09-.133.042-.064.079-.131.135-.184.006-.005.008-.013.014-.019l4.401-4A1 1 0 015.4 0zM18 6H2v16h16V6zm4-2.586l-2 2v14.999l2-2.2V3.414zM13 8a1 1 0 110 2H7a1 1 0 110-2zm-1.186-6H5.787l-2.2 2h6.026l2.201-2zm8.772 0h-5.799l-2.2 2h5.999l2-2z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconArchive;